import { render } from "./AIAssessmentComponent.vue?vue&type=template&id=5d8d7ce5"
import script from "./AIAssessmentComponent.vue?vue&type=script&lang=js"
export * from "./AIAssessmentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__